import { UserAttributeDefs } from "@iotv/datamodel-core";
import { Position, ValidBusinessObject } from "@iotv/iotv-v3-types";
import { Storage as V020Storage } from "./Storage";

const typeName = "EffluentPond";

export type EffluentPondProps = {
  purpose?: string;
  capacity?: number;
  current_filled_volume?: number;
  last_filled_volume?: number;
  current_height?: number;
  depth?: number;
  // shape?: TankShape;
  surfaceWidth?: number;
  bottomWidth?: number;
  surfaceLength?: number;
  bottomLength?: number;
  // length?: number;
  constructionMaterial?: string;
  location?: Position;
  total_volume?: number;
  image?: string;
};

export class EffluentPond extends V020Storage {
  constructor(ob: ValidBusinessObject) {
    super({ ...ob, typeName });
    this.currentVolume = ob.current_filled_volume;
  }

  purpose?: string;
  capacity?: number;
  current_filled_volume?: number;
  last_filled_volume?: number;
  mountHeight?: number;
  depth?: number;
  current_height?: number;
  // shape?: TankShape;
  surfaceWidth?: number;
  bottomWidth?: number;
  surfaceLength?: number;
  bottomLength?: number;
  // length?: number;
  constructionMaterial?: string;
  location?: Position;
  total_volume?: number;
  // image?: string;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: {
        type: "String",
        editable: true,
        label: "Name",
        name: "name",
        description: "Name of Effluent Pond",
        required: true,
      },
      purpose: {
        type: "String",
        editable: true,
        label: "Purpose",
        name: "purpose",
        description: "Used for",
      },
      // capacity: {
      //   type: 'Number',
      //   editable: true,
      //   label: 'Capacity',
      //   name: 'capacity',
      //   description: 'Total storage capacity of Effluent Pond in m3 and litres',
      // },
      last_filled_volume: {
        type: "Number",
        editable: false,
        label: "Last Filled Volume",
        name: "last_filled_volume",
        description: "The last volume in the pond",
      },
      current_height: {
        type: "Number",
        editable: false,
        label: "Current Height",
        name: "current_height",
        description: "The current Height in the pond",
      },
      // current_filled_volume: {
      //   type: "Number",
      //   editable: false,
      //   label: "Current Volume",
      //   name: "currentVolume",
      //   description: "The current volume in the pond",
      // },
      depth: {
        type: "Number",
        editable: true,
        label: "Depth/height (m)",
        name: "depth/Height",
        description: "Depth/ Height of Effluent Pond in m",
        required: true,
      },
      mountHeight: {
        type: "Number",
        editable: true,
        label: "Mount Height (m)",
        name: "Mount Height",
        description: "Mount Height of Effluent Pond in m",
        required: true,
      },
      surfaceWidth: {
        type: "Number",
        editable: true,
        label: "Surface Width (m)",
        name: "Surface Width",
        description: "Surface Width if rectangle",
        required: true,
      },
      bottomWidth: {
        type: "Number",
        editable: true,
        label: "Bottom Width (m)",
        name: "Bottom Width",
        description: "Bottom Width if rectangle",
        required: true,
      },
      surfaceLength: {
        type: "Number",
        editable: true,
        label: "Surface Length (m)",
        name: "Surface Length",
        description: "Length of recentangle",
        required: true,
      },
      bottomLength: {
        type: "Number",
        editable: true,
        label: "Bottom Length (m)",
        name: "Bottom Length",
        description: "Length of recentangle",
        required: true,
      },
      // length: {
      //   type: "Number",
      //   editable: true,
      //   label: "Length ",
      //   name: "length",
      //   description: "Length if rectangle",
      // },
      constructionMaterial: {
        type: "String",
        editable: true,
        label: "Construction material",
        name: "constructionMaterial",
        description: "Material Effluent Pond is contructed from",
      },
      location: {
        type: "object",
        editable: true,
        label: "Location",
        name: "location",
        description: "Location of  Effluent Pond (lat/ long)",
      },
      // image: {
      //   type: 'String',
      //   editable: true,
      //   label: 'Image',
      //   name: 'image',
      //   description: 'Photograph of Effluent Pond',
      // },
      comments: {
        type: "String",
        editable: true,
        label: "Comments",
        name: "comments",
        description: "Free text for info ",
      },
    };
  }
}
